import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Countries } from 'src/app/_global/countries';

@Component({
  selector: 'app-customer-details',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule],
  templateUrl: './customer-details.component.html'
})
export class CustomerDetailsComponent {
  @Input() form: UntypedFormGroup;
  @Input() countries: Countries;
  @Input() idPrefix = 'customer';

  readonly contactFields = [
    { control: 'name', label: 'Customer name', required: true, type: 'text', autocomplete: 'organization' },
    { control: 'recipientName', label: 'Recipient name', required: false, type: 'text', autocomplete: 'shipping name' },
    { control: 'email', label: 'Email', required: true, type: 'email', autocomplete: 'email' },
    { control: 'phoneNumber', label: 'Phone', required: false, type: 'tel', autocomplete: 'tel' }
  ];
  readonly addressFields = [
    { control: 'address1', label: 'Street address', required: true, type: 'text', autocomplete: 'shipping address-line1' },
    { control: 'address2', label: 'Apartment or suite', required: false, type: 'text', autocomplete: 'shipping address-line2' },
    { control: 'city', label: 'City', required: true, type: 'text', autocomplete: 'shipping address-level2' },
    { control: 'district', label: 'District', required: false, type: 'text', autocomplete: 'off' },
    { control: 'county', label: 'County', required: false, type: 'text', autocomplete: 'off' },
    { control: 'postalCode', label: 'ZIP or postal code', required: false, type: 'text', autocomplete: 'shipping postal-code' }
  ];

  invalid(control: string): boolean {
    const field = this.form.get(control);
    return !!field && field.invalid && (field.dirty || field.touched);
  }
}
